exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-item-daterange[data-v-3e2a6d1c] .el-range-separator{width:20px}\n", ""]);

// exports
